import _ from "lodash";
import { Moment } from "moment";
import { IWeekDay, } from "../../LiteTrade/types/liteTradeReducer.t";
import { IAssetWeekDaySchedule } from "../Asset.t";

export const getStartDateOfBiddingForWeek = (weekSchedule: IAssetWeekDaySchedule[], currentDay: Moment): number => {
    const currentDayClone = currentDay.clone();
    let count = 0;
    // search in 2 weeks
    while (count < 14) {
        const indexOfday = _.findIndex(
            weekSchedule,
            (weekDay) => weekDay.weekDay === currentDayClone.format("dddd") as IWeekDay
        );
        const timeNow = currentDayClone.format("HH:mm");
        if (indexOfday !== -1) {
            const nearestDay = weekSchedule[indexOfday];
            const list = nearestDay.intervals;
            const len = list.length;
            if (count === 0 && list.find(interval => timeNow >= interval.startTime && timeNow <= interval.endTime)) {
                return currentDay.valueOf();
            } else {
                for (let index = 0; index < len; index++) {
                    const startPeriod = index === 0 ? '00:00' : list[index - 1].endTime;
                    const endPeriond = list[index].startTime
                    if (timeNow >= startPeriod && timeNow <= endPeriond) {
                        const [hour, minute] = endPeriond.split(':').map(Number);
                        currentDayClone.set({ hour, minute, second:0, millisecond:0 })
                        return currentDayClone.valueOf();
                    }
                }
            }
        }
        count++;
        currentDayClone.set({ hour: 0, minute: 0, second:0, millisecond:0 })
        currentDayClone.add(1, 'd');

    }
    // expect if we didn't find any, we are traiding now
    return currentDay.valueOf();
}

export default getStartDateOfBiddingForWeek;